export default "__VITE_ASSET__Bc30xkp2__"